// extracted by mini-css-extract-plugin
export default {"animate-fetching":"AKc6QJqUqAbY0_xiz26r","animate":"GWH2_RcZoICC3t6LXRy5"};